var t = require('i18n').t
var NOTIFICATION_KEYS = require('../notificationKeys')

module.exports = Em.Route.extend({
    queryParams: [
        'mobilepaystatus',
        'mobilepayerror'
    ],

    userOrganizations: Em.inject.service(),

    organization: Em.computed.alias('userOrganizations.activeOrganization'),

    setup: function(context) {
        if (context.invoice && this.didFindByInclude !== true) {
            BD.store.findByIdInclude(context.invoice.constructor, context.invoice.get('id'), 'invoice.delivery')
        }
        this._super.apply(this, arguments)
    },

    beforeModel: function() {
        var self = this
        var invoice = this.modelFor('invoice')

        return new Em.RSVP.Promise(function(resolve, reject) {
            invoice.promise.then(function() {
                if (invoice.get('isDraft')) {
                    self.transitionTo('invoice.edit', invoice)
                } else {
                    resolve()
                }
            }, reject)
        })
    },

    model: function() {
        var invoice = this.modelFor('invoice')
        return Em.RSVP.hash({
            invoice: invoice
        })
    },

    setupController: function(controller, models, transition) {
        var params = transition.queryParams
        var mobilepayMessage = null

        if (params.mobilepaystatus === 'success') {
            mobilepayMessage = t('payment_methods.mobilepay.success')
            this.container.lookup('util:notification').success(NOTIFICATION_KEYS.MOBILEPAY_CREATE, mobilepayMessage)
        } else if (params.mobilepaystatus === 'error') {
            switch (params.mobilepayerror) {
            case 'E_INSUFFICIENT_SCOPE':
                mobilepayMessage = t('payment_methods.mobilepay.error.insufficient_scope')
                break
            case 'E_INVALID_STATE':
                mobilepayMessage = t('payment_methods.mobilepay.error.invalid_state')
                break
            case 'E_MISSING_ISSUER':
                mobilepayMessage = t('payment_methods.mobilepay.error.missing_issuer')
                break
            default:
                mobilepayMessage = t('payment_methods.mobilepay.failed')
                break
            }
            this.container.lookup('util:notification').warn(NOTIFICATION_KEYS.MOBILEPAY_CREATE, mobilepayMessage)
        }

        this._super.apply(this, arguments)
        controller.set('model', models.invoice)
        controller.loadHtml()
        controller.activate()
    },

    resetController: function(controller) {
        controller.set('justApproved', false)
    },

    actions: {
        invalidateModel: function() {
            this.refresh()
        }
    }
})
